import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';

export const swiperContainer = css({
  '.swiper-pagination-bullet': {
    width: 5,
    height: 5,
  },
  '.swiper-pagination-bullet-active': {
    background: colorsPalette.red,
  },
});
